import { Form, Input, InputNumber, Select, Space, Typography } from 'antd'

import { SizeProbe } from './SizeProbe'

export function SourceFields() {
  const form = Form.useFormInstance()
  const kind = Form.useWatch(['source', 'kind'], form)
  return (
    <>
      <Form.Item
        name={['source', 'kind']}
        label="Creation method"
        rules={[{ required: true }]}
      >
        <Select
          options={[
            { value: 'HTTP', label: 'HTTP download' },
            { value: 'IMAGE', label: 'Prepared image (clone)' },
          ]}
        />
      </Form.Item>
      <Form.Item
        name={['source', 'downloadUrl']}
        label="Image URL"
        dependencies={[['source', 'kind']]}
        extra={
          kind === 'IMAGE'
            ? 'HTTPS URL of a .qcow2, .img, .raw, .raw.xz, .raw.gz, .img.xz or .img.gz file. No credentials or fragment.'
            : undefined
        }
        rules={[
          { required: true },
          { type: 'url', warningOnly: false },
          { pattern: /^https?:\/\//, message: 'Use an HTTP or HTTPS URL' },
          {
            validator: async (_, value: string | undefined) => {
              if (!value || kind !== 'IMAGE') return
              try {
                const url = new URL(value)
                if (
                  url.protocol === 'https:' &&
                  !url.username &&
                  !url.password &&
                  !url.hash &&
                  !value.includes('#') &&
                  url.href.length <= 16384 &&
                  /\.(qcow2|img|raw|raw\.xz|raw\.gz|img\.xz|img\.gz)$/.test(
                    url.pathname,
                  )
                )
                  return
              } catch {
                /* The rule below reports invalid image URLs. */
              }
              throw new Error(
                'Use an HTTPS image file URL without credentials or a fragment',
              )
            },
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Space align="start" wrap>
        <Form.Item
          name={['source', 'username']}
          label="Guest username"
          rules={[{ required: true }, { min: 3 }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={['source', 'bootMode']}
          label="Boot mode"
          rules={[{ required: true }]}
        >
          <Select
            style={{ width: 140 }}
            options={[{ value: 'BIOS' }, { value: 'EFI' }]}
          />
        </Form.Item>
      </Space>
      {kind === 'IMAGE' && (
        <>
          <Form.Item
            name={['source', 'virtualSize']}
            label="Virtual disk size (bytes)"
            rules={[
              { required: true },
              { type: 'integer', min: 1, max: Number.MAX_SAFE_INTEGER },
            ]}
            extra="Uncompressed virtual capacity, not the download size."
          >
            <InputNumber
              style={{ width: '100%' }}
              min={1}
              max={Number.MAX_SAFE_INTEGER}
              precision={0}
            />
          </Form.Item>
          <SizeProbe />
          <Form.Item
            name={['source', 'sha256']}
            label="SHA-256 (optional)"
            rules={[
              {
                pattern: /^[a-f0-9]{64}$/,
                message: 'Enter 64 lowercase hexadecimal characters',
              },
            ]}
            extra="Checksum of the exact file. The size helper does not calculate it."
          >
            <Input />
          </Form.Item>
        </>
      )}
      <Typography.Paragraph type="secondary">
        The source cannot be edited after creation. Use a new entry for a
        different file.
      </Typography.Paragraph>
    </>
  )
}
